const activity = [
  {
    "web-scraper-order": "1666025637-818",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏹 Bow and Arrow",
    "activity-href": "https://emojipedia.org/bow-and-arrow/",
    emoji: "🏹",
    emojiName: "🏹 Bow and Arrow",
    description:
      "A bow and arrow used in the sport of archery. May also be used by cupid.",
  },
  {
    "web-scraper-order": "1666025640-819",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎬 Clapper Board",
    "activity-href": "https://emojipedia.org/clapper-board/",
    emoji: "🎬",
    emojiName: "🎬 Clapper Board",
    description:
      "A board which contains the scene name, number, and film. A person ‘claps’ the board shut at the top while saying “Action” or “Cut” to indicate the start and stop of a scene that is being filmed.",
  },
  {
    "web-scraper-order": "1666025645-820",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🪘 Long Drum",
    "activity-href": "https://emojipedia.org/long-drum/",
    emoji: "🪘",
    emojiName: "🪘 Long Drum",
    description:
      "A long drum with a tall body and a cylindrical or hourglass shell. Can be used to represent various drums found around the world from Africa to the Caribbean to Latin America to Asia. Types of long drum include (but are not limited to) djembe, talking drum, conga, bongo, tumbadora, atabaque, and dhol.",
  },
  {
    "web-scraper-order": "1666025650-821",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥁 Drum",
    "activity-href": "https://emojipedia.org/drum/",
    emoji: "🥁",
    emojiName: "🥁 Drum",
    description:
      "A drum shown with drumsticks. A percussion instrument which is likely to be displayed as a snare drum.music, instrument,",
  },
  {
    "web-scraper-order": "1666025653-822",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎻 Violin",
    "activity-href": "https://emojipedia.org/violin/",
    emoji: "🎻",
    emojiName: "🎻 Violin",
    description:
      "A violin emoji. Sometimes used in the context of the world’s smallest violin.",
  },
  {
    "web-scraper-order": "1666025657-823",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎺 Trumpet",
    "activity-href": "https://emojipedia.org/trumpet/",
    emoji: "🎺",
    emojiName: "🎺 Trumpet",
    description: "A trumpet, a brass instrument played in jazz bands.",
  },
  {
    "web-scraper-order": "1666025660-824",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎹 Musical Keyboard",
    "activity-href": "https://emojipedia.org/musical-keyboard/",
    emoji: "🎹",
    emojiName: "🎹 Musical Keyboard",
    description:
      "A small section of a music keyboard, which differs from a computer keyboard.",
  },
  {
    "web-scraper-order": "1666025662-825",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎸 Guitar",
    "activity-href": "https://emojipedia.org/guitar/",
    emoji: "🎸",
    emojiName: "🎸 Guitar",
    description:
      "A guitar, which most platforms display as a red electric guitar.",
  },
  {
    "web-scraper-order": "1666025665-826",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🪗 Accordion",
    "activity-href": "https://emojipedia.org/accordion/",
    emoji: "🪗",
    emojiName: "🪗 Accordion",
    description:
      "A red accordion with a keyboard on one side, buttons on the other side, and bellows in the middle. Used to talk about accordion music or music in general. Also may be used in reference to things that expand and contract, or are folded like the bellows of an accordion.",
  },
  {
    "web-scraper-order": "1666025667-827",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎷 Saxophone",
    "activity-href": "https://emojipedia.org/saxophone/",
    emoji: "🎷",
    emojiName: "🎷 Saxophone",
    description:
      "Saxophone was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025670-828",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎧 Headphone",
    "activity-href": "https://emojipedia.org/headphone/",
    emoji: "🎧",
    emojiName: "🎧 Headphone",
    description:
      "Headphones, used to listen to music or other forms audio, such as podcasts. Most platforms display this emoji with large over-ear headphones in shades of black, blue, and gray.",
  },
  {
    "web-scraper-order": "1666025673-829",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎤 Microphone",
    "activity-href": "https://emojipedia.org/microphone/",
    emoji: "🎤",
    emojiName: "🎤 Microphone",
    description:
      "A microphone, used to amplify a person’s voice when speaking or singing.",
  },
  {
    "web-scraper-order": "1666025675-830",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎼 Musical Score",
    "activity-href": "https://emojipedia.org/musical-score/",
    emoji: "🎼",
    emojiName: "🎼 Musical Score",
    description:
      "A staff (or stave) showing a treble clef and five horizontal lines.",
  },
  {
    "web-scraper-order": "1666025678-831",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧶 Yarn",
    "activity-href": "https://emojipedia.org/yarn/",
    emoji: "🧶",
    emojiName: "🧶 Yarn",
    description:
      "A ball of yarn, as used to knit a scarf. Color varies across platforms, but often depicted in green, blue, or magenta and shown with an end unraveling. Sometimes depicted with a pair of knitting needles stuck in the ball.",
  },
  {
    "web-scraper-order": "1666025680-832",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧵 Thread",
    "activity-href": "https://emojipedia.org/thread/",
    emoji: "🧵",
    emojiName: "🧵 Thread",
    description:
      "A spool of thread, as used for sewing. Thread color varies across platforms, though often depicted in red or blue and on a wooden spool. Sometimes shown with an end unraveling.",
  },
  {
    "web-scraper-order": "1666025683-833",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎨 Artist Palette",
    "activity-href": "https://emojipedia.org/artist-palette/",
    emoji: "🎨",
    emojiName: "🎨 Artist Palette",
    description:
      "A palette used by an artist when painting, to store and mix paint colors.",
  },
  {
    "web-scraper-order": "1666025686-834",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎭 Performing Arts",
    "activity-href": "https://emojipedia.org/performing-arts/",
    emoji: "🎭",
    emojiName: "🎭 Performing Arts",
    description:
      "Two masks often used on maps to indicate a theatre, these originate in Greek Theatre as masks of tragedy and comedy.",
  },
  {
    "web-scraper-order": "1666025688-835",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "♟️ Chess Pawn",
    "activity-href": "https://emojipedia.org/chess-pawn/",
    emoji: "♟️",
    emojiName: "♟️ Chess Pawn",
    description:
      "Chess Pawn was approved as part of Unicode 1.1 in 1993 under the name “Black Chess Pawn” and added to Emoji 11.0 in 2018.",
  },
  {
    "web-scraper-order": "1666025690-836",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🪩 Mirror Ball",
    "activity-href": "https://emojipedia.org/mirror-ball/",
    emoji: "🪩",
    emojiName: "🪩 Mirror Ball",
    description:
      "A mirror ball, also called a disco ball. A hanging sphere made up of a bunch of tiny mirrors, which reflect spots of light around a room, creating a party atmosphere.",
  },
  {
    "web-scraper-order": "1666025693-837",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧩 Puzzle Piece",
    "activity-href": "https://emojipedia.org/puzzle-piece/",
    emoji: "🧩",
    emojiName: "🧩 Puzzle Piece",
    description:
      "Puzzle Piece was approved as part of Unicode 11.0 in 2018 under the name “Jigsaw Puzzle Piece” and added to Emoji 11.0 in 2018.",
  },
  {
    "web-scraper-order": "1666025696-838",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎲 Game Die",
    "activity-href": "https://emojipedia.org/game-die/",
    emoji: "🎲",
    emojiName: "🎲 Game Die",
    description:
      "A six-sided die, used in a range of board and turn-based games. Commonly called dice which refers to the plural of die.",
  },
  {
    "web-scraper-order": "1666025698-839",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎰 Slot Machine",
    "activity-href": "https://emojipedia.org/slot-machine/",
    emoji: "🎰",
    emojiName: "🎰 Slot Machine",
    description:
      "A gambling machine generally found in casinos. Shows three wheels with a lever to the side. Most platforms display three 7 digits on this emoji.",
  },
  {
    "web-scraper-order": "1666025701-840",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎮 Video Game",
    "activity-href": "https://emojipedia.org/video-game/",
    emoji: "🎮",
    emojiName: "🎮 Video Game",
    description:
      "A video game emoji, shown on major platforms as a console gamepad with D-pad, joysticks, and buttons.",
  },
  {
    "web-scraper-order": "1666025704-841",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎱 Pool 8 Ball",
    "activity-href": "https://emojipedia.org/pool-8-ball/",
    emoji: "🎱",
    emojiName: "🎱 Pool 8 Ball",
    description:
      "This emoji displays the black 8 ball on most platforms, which looks similar to the Magic 8-Ball toy. This is despite the fact that emoji was originally created intending to represent game of billiards, of which pool is a common version.",
  },
  {
    "web-scraper-order": "1666025707-842",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎯 Bullseye",
    "activity-href": "https://emojipedia.org/direct-hit/",
    emoji: "🎯",
    emojiName: "🎯 Bullseye",
    description: "A dart board with dart hitting the center / bullseye region.",
  },
  {
    "web-scraper-order": "1666025710-843",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥌 Curling Stone",
    "activity-href": "https://emojipedia.org/curling-stone/",
    emoji: "🥌",
    emojiName: "🥌 Curling Stone",
    description:
      "Curling Stone was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
  },
  {
    "web-scraper-order": "1666025713-844",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🛷 Sled",
    "activity-href": "https://emojipedia.org/sled/",
    emoji: "🛷",
    emojiName: "🛷 Sled",
    description: "A sled, otherwise known as a toboggan or sledge.",
  },
  {
    "web-scraper-order": "1666025716-845",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎿 Skis",
    "activity-href": "https://emojipedia.org/skis/",
    emoji: "🎿",
    emojiName: "🎿 Skis",
    description:
      "A pair of skis which are shown on some platforms alongside ski poles and/or ski boots. The color and design of the skis varies by platform, with some versions also showing the skis moving at speed.",
  },
  {
    "web-scraper-order": "1666025719-846",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎽 Running Shirt",
    "activity-href": "https://emojipedia.org/running-shirt/",
    emoji: "🎽",
    emojiName: "🎽 Running Shirt",
    description: "A singlet or running shirt. Shown with a sash.",
  },
  {
    "web-scraper-order": "1666025722-847",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎣 Fishing Pole",
    "activity-href": "https://emojipedia.org/fishing-pole/",
    emoji: "🎣",
    emojiName: "🎣 Fishing Pole",
    description: "A fishing rod (pole) with a fish caught on the end.",
  },
  {
    "web-scraper-order": "1666025725-848",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛸️ Ice Skate",
    "activity-href": "https://emojipedia.org/ice-skate/",
    emoji: "⛸️",
    emojiName: "⛸️ Ice Skate",
    description:
      "A single ice skate used for ice skating. Shown in white and facing right on most platforms.",
  },
  {
    "web-scraper-order": "1666025728-849",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛳ Flag in Hole",
    "activity-href": "https://emojipedia.org/flag-in-hole/",
    emoji: "⛳",
    emojiName: "⛳ Flag in Hole",
    description:
      "A red, triangular flag shown sitting in the hole of a golf course green. Some versions of this emoji also include golf balls, with an early iOS design simply depicting a single golf ball.",
  },
  {
    "web-scraper-order": "1666025730-850",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥅 Goal Net",
    "activity-href": "https://emojipedia.org/goal-net/",
    emoji: "🥅",
    emojiName: "🥅 Goal Net",
    description:
      "Goal Net was approved as part of Unicode 9.0 in 2016 and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025732-851",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥋 Martial Arts Uniform",
    "activity-href": "https://emojipedia.org/martial-arts-uniform/",
    emoji: "🥋",
    emojiName: "🥋 Martial Arts Uniform",
    description:
      "A white uniform used in marital arts such as judo or karate. Held together using a material belt. Known as keikogi in Japanese.",
  },
  {
    "web-scraper-order": "1666025735-852",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥊 Boxing Glove",
    "activity-href": "https://emojipedia.org/boxing-glove/",
    emoji: "🥊",
    emojiName: "🥊 Boxing Glove",
    description:
      "A padded boxing glove, used in the sport of boxing. Usually red.",
  },
  {
    "web-scraper-order": "1666025738-853",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏸 Badminton",
    "activity-href": "https://emojipedia.org/badminton/",
    emoji: "🏸",
    emojiName: "🏸 Badminton",
    description:
      "Badminton was approved as part of Unicode 8.0 in 2015 under the name “Badminton Racquet and Shuttlecock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025741-854",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏓 Ping Pong",
    "activity-href": "https://emojipedia.org/ping-pong/",
    emoji: "🏓",
    emojiName: "🏓 Ping Pong",
    description:
      "A paddle and ping pong ball used in the sport of table tennis.",
  },
  {
    "web-scraper-order": "1666025743-855",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥍 Lacrosse",
    "activity-href": "https://emojipedia.org/lacrosse/",
    emoji: "🥍",
    emojiName: "🥍 Lacrosse",
    description:
      "Lacrosse was approved as part of Unicode 11.0 in 2018 under the name “Lacrosse Stick and Ball” and added to Emoji 11.0 in 2018.",
  },
  {
    "web-scraper-order": "1666025746-856",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏒 Ice Hockey",
    "activity-href": "https://emojipedia.org/ice-hockey/",
    emoji: "🏒",
    emojiName: "🏒 Ice Hockey",
    description:
      "A hockey stick and puck, used in the sport of ice hockey. Not to be confused with the field hockey stick and ball.",
  },
  {
    "web-scraper-order": "1666025748-857",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏑 Field Hockey",
    "activity-href": "https://emojipedia.org/field-hockey/",
    emoji: "🏑",
    emojiName: "🏑 Field Hockey",
    description:
      "A hockey stick and ball, used in the sport of field hockey. Not to be confused with the ice hockey stick and puck.",
  },
  {
    "web-scraper-order": "1666025751-858",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏏 Cricket Game",
    "activity-href": "https://emojipedia.org/cricket-game/",
    emoji: "🏏",
    emojiName: "🏏 Cricket Game",
    description:
      "A cricket bat, with a cricket ball also shown. May be displayed with a wicket present.",
  },
  {
    "web-scraper-order": "1666025754-859",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎳 Bowling",
    "activity-href": "https://emojipedia.org/bowling/",
    emoji: "🎳",
    emojiName: "🎳 Bowling",
    description: "Ten-pin bowling emoji, showing a bowling ball and pins.",
  },
  {
    "web-scraper-order": "1666025757-860",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥏 Flying Disc",
    "activity-href": "https://emojipedia.org/flying-disc/",
    emoji: "🥏",
    emojiName: "🥏 Flying Disc",
    description:
      "A flying disc, more commonly known as a frisbee. Used in the sport of Ultimate or disc golf.",
  },
  {
    "web-scraper-order": "1666025760-861",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎾 Tennis",
    "activity-href": "https://emojipedia.org/tennis/",
    emoji: "🎾",
    emojiName: "🎾 Tennis",
    description:
      "A tennis racket (racquet) with a tennis ball. Only a ball is shown on certain platforms, including Apple, Twitter, and WhatsApp.",
  },
  {
    "web-scraper-order": "1666025763-862",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏉 Rugby Football",
    "activity-href": "https://emojipedia.org/rugby-football/",
    emoji: "🏉",
    emojiName: "🏉 Rugby Football",
    description:
      "The oval-shaped ball used in the game of rugby. Varies slightly in shape in the two main versions of the game: rugby union and rugby league.",
  },
  {
    "web-scraper-order": "1666025765-863",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏈 American Football",
    "activity-href": "https://emojipedia.org/american-football/",
    emoji: "🏈",
    emojiName: "🏈 American Football",
    description:
      "The oval ball used in the game of American football, known as gridiron in some countries.",
  },
  {
    "web-scraper-order": "1666025768-864",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏐 Volleyball",
    "activity-href": "https://emojipedia.org/volleyball/",
    emoji: "🏐",
    emojiName: "🏐 Volleyball",
    description:
      "A volleyball emoji, showing the round ball used in the sport. Played as part of the Summer Olympic Games.",
  },
  {
    "web-scraper-order": "1666025770-865",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏀 Basketball",
    "activity-href": "https://emojipedia.org/basketball/",
    emoji: "🏀",
    emojiName: "🏀 Basketball",
    description:
      "An orange-colored basketball. Originally intended to display as a basketball and a hoop, as per previous designs by Google, Samsung, and Microsoft.",
  },
  {
    "web-scraper-order": "1666025773-866",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥎 Softball",
    "activity-href": "https://emojipedia.org/softball/",
    emoji: "🥎",
    emojiName: "🥎 Softball",
    description:
      "A softball, which is differentiated from a baseball by size (it is larger, though hard to tell in emoji form) and color (yellow, not white).",
  },
  {
    "web-scraper-order": "1666025776-867",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⚾ Baseball",
    "activity-href": "https://emojipedia.org/baseball/",
    emoji: "⚾",
    emojiName: "⚾ Baseball",
    description:
      "A white baseball, with regulation red stitching. Used in the game of the same name, baseball.",
  },
  {
    "web-scraper-order": "1666025779-868",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⚽ Soccer Ball",
    "activity-href": "https://emojipedia.org/soccer-ball/",
    emoji: "⚽",
    emojiName: "⚽ Soccer Ball",
    description:
      "A round, black and white ball used in the game of soccer, which is known as football in much of the world. See also: emojis for the World Cup.",
  },
  {
    "web-scraper-order": "1666025781-869",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥉 3rd Place Medal",
    "activity-href": "https://emojipedia.org/3rd-place-medal/",
    emoji: "🥉",
    emojiName: "🥉 3rd Place Medal",
    description:
      "3rd Place Medal was approved as part of Unicode 9.0 in 2016 under the name “Third Place Medal” and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025784-870",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥈 2nd Place Medal",
    "activity-href": "https://emojipedia.org/2nd-place-medal/",
    emoji: "🥈",
    emojiName: "🥈 2nd Place Medal",
    description:
      "2nd Place Medal was approved as part of Unicode 9.0 in 2016 under the name “Second Place Medal” and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025786-871",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥇 1st Place Medal",
    "activity-href": "https://emojipedia.org/1st-place-medal/",
    emoji: "🥇",
    emojiName: "🥇 1st Place Medal",
    description:
      "1st Place Medal was approved as part of Unicode 9.0 in 2016 under the name “First Place Medal” and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025789-872",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏅 Sports Medal",
    "activity-href": "https://emojipedia.org/sports-medal/",
    emoji: "🏅",
    emojiName: "🏅 Sports Medal",
    description:
      "A gold medal, given to a person who has won a sporting event, such as a race. Not to be confused with the military medal emoji.",
  },
  {
    "web-scraper-order": "1666025792-873",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏆 Trophy",
    "activity-href": "https://emojipedia.org/trophy/",
    emoji: "🏆",
    emojiName: "🏆 Trophy",
    description:
      "A trophy given as an recognition of achievement, usually in sports. The trophy emoji is a gold cup, with a engraving on the bottom detailing the award.",
  },
  {
    "web-scraper-order": "1666025794-874",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎖️ Military Medal",
    "activity-href": "https://emojipedia.org/military-medal/",
    emoji: "🎖️",
    emojiName: "🎖️ Military Medal",
    description:
      "A ribbon and medallion generally awarded to a person in the military for heroic acts.",
  },
  {
    "web-scraper-order": "1666025797-875",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎫 Ticket",
    "activity-href": "https://emojipedia.org/ticket/",
    emoji: "🎫",
    emojiName: "🎫 Ticket",
    description:
      "A paper ticket, which may be for a theatre show, sporting event, or other ticketed performance. Shown in blue, yellow or grey on most platforms.",
  },
  {
    "web-scraper-order": "1666025800-876",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎟️ Admission Tickets",
    "activity-href": "https://emojipedia.org/admission-tickets/",
    emoji: "🎟️",
    emojiName: "🎟️ Admission Tickets",
    description:
      'A ticket or tickets to an event that may say "Admit One" on the front. Shown in pink or yellow on most platforms.',
  },
  {
    "web-scraper-order": "1666025802-877",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎗️ Reminder Ribbon",
    "activity-href": "https://emojipedia.org/reminder-ribbon/",
    emoji: "🎗️",
    emojiName: "🎗️ Reminder Ribbon",
    description:
      "An awareness ribbon, worn to show support of a cause or group.",
  },
  {
    "web-scraper-order": "1666025805-878",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🛶 Canoe",
    "activity-href": "https://emojipedia.org/canoe/",
    emoji: "🛶",
    emojiName: "🛶 Canoe",
    description:
      "Canoe was approved as part of Unicode 9.0 in 2016 and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025810-879",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🛼 Roller Skate",
    "activity-href": "https://emojipedia.org/roller-skate/",
    emoji: "🛼",
    emojiName: "🛼 Roller Skate",
    description:
      "A single vibrantly colored roller skate. Colors and styles vary across platform.",
  },
  {
    "web-scraper-order": "1666025815-881",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🛹 Skateboard",
    "activity-href": "https://emojipedia.org/skateboard/",
    emoji: "🛹",
    emojiName: "🛹 Skateboard",
    description: "A skateboard emoji, usually showing the board from the top.",
  },
  {
    "web-scraper-order": "1666025818-883",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎪 Circus Tent",
    "activity-href": "https://emojipedia.org/circus-tent/",
    emoji: "🎪",
    emojiName: "🎪 Circus Tent",
    description:
      "A circular ‘big top’ circus tent, with a triangle flag on top.",
  },
  {
    "web-scraper-order": "1666025823-885",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧘‍♀️ Woman in Lotus Position",
    "activity-href": "https://emojipedia.org/woman-in-lotus-position/",
    emoji: "🧘‍♀️",
    emojiName: "🧘‍♀️ Woman in Lotus Position",
    description:
      "The Woman in Lotus Position emoji is a ZWJ sequence combining 🧘 Person in Lotus Position, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025828-888",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧘‍♂️ Man in Lotus Position",
    "activity-href": "https://emojipedia.org/man-in-lotus-position/",
    emoji: "🧘‍♂️",
    emojiName: "🧘‍♂️ Man in Lotus Position",
    description:
      "The Man in Lotus Position emoji is a ZWJ sequence combining 🧘 Person in Lotus Position, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025833-890",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧘 Person in Lotus Position",
    "activity-href": "https://emojipedia.org/person-in-lotus-position/",
    emoji: "🧘",
    emojiName: "🧘 Person in Lotus Position",
    description:
      "Person in Lotus Position was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
  },
  {
    "web-scraper-order": "1666025840-894",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤹‍♀️ Woman Juggling",
    "activity-href": "https://emojipedia.org/woman-juggling/",
    emoji: "🤹‍♀️",
    emojiName: "🤹‍♀️ Woman Juggling",
    description:
      "The Woman Juggling emoji is a ZWJ sequence combining 🤹 Person Juggling, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025845-897",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤹‍♂️ Man Juggling",
    "activity-href": "https://emojipedia.org/man-juggling/",
    emoji: "🤹‍♂️",
    emojiName: "🤹‍♂️ Man Juggling",
    description:
      "The Man Juggling emoji is a ZWJ sequence combining 🤹 Person Juggling, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025851-898",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤹 Person Juggling",
    "activity-href": "https://emojipedia.org/person-juggling/",
    emoji: "🤹",
    emojiName: "🤹 Person Juggling",
    description:
      "A person juggling between three and five colored balls. The person shown in this emoji wears a hat on most major platforms.",
  },
  {
    "web-scraper-order": "1666025855-899",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤾‍♀️ Woman Playing Handball",
    "activity-href": "https://emojipedia.org/woman-playing-handball/",
    emoji: "🤾‍♀️",
    emojiName: "🤾‍♀️ Woman Playing Handball",
    description:
      "The Woman Playing Handball emoji is a ZWJ sequence combining 🤾 Person Playing Handball, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025859-900",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤾‍♂️ Man Playing Handball",
    "activity-href": "https://emojipedia.org/man-playing-handball/",
    emoji: "🤾‍♂️",
    emojiName: "🤾‍♂️ Man Playing Handball",
    description:
      "The Man Playing Handball emoji is a ZWJ sequence combining 🤾 Person Playing Handball, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025862-902",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤾 Person Playing Handball",
    "activity-href": "https://emojipedia.org/person-playing-handball/",
    emoji: "🤾",
    emojiName: "🤾 Person Playing Handball",
    description:
      "Person Playing Handball was approved as part of Unicode 9.0 in 2016 under the name “Handball” and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025868-905",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤽‍♀️ Woman Playing Water Polo",
    "activity-href": "https://emojipedia.org/woman-playing-water-polo/",
    emoji: "🤽‍♀️",
    emojiName: "🤽‍♀️ Woman Playing Water Polo",
    description:
      "The Woman Playing Water Polo emoji is a ZWJ sequence combining 🤽 Person Playing Water Polo, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025874-907",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤽‍♂️ Man Playing Water Polo",
    "activity-href": "https://emojipedia.org/man-playing-water-polo/",
    emoji: "🤽‍♂️",
    emojiName: "🤽‍♂️ Man Playing Water Polo",
    description:
      "The Man Playing Water Polo emoji is a ZWJ sequence combining 🤽 Person Playing Water Polo, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025877-909",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤽 Person Playing Water Polo",
    "activity-href": "https://emojipedia.org/person-playing-water-polo/",
    emoji: "🤽",
    emojiName: "🤽 Person Playing Water Polo",
    description:
      "A person shown in water with a ball, playing the sport of water polo.",
  },
  {
    "web-scraper-order": "1666025883-911",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤼‍♀️ Women Wrestling",
    "activity-href": "https://emojipedia.org/women-wrestling/",
    emoji: "🤼‍♀️",
    emojiName: "🤼‍♀️ Women Wrestling",
    description:
      "The Women Wrestling emoji is a ZWJ sequence combining 🤼 People Wrestling, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025888-913",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤼‍♂️ Men Wrestling",
    "activity-href": "https://emojipedia.org/men-wrestling/",
    emoji: "🤼‍♂️",
    emojiName: "🤼‍♂️ Men Wrestling",
    description:
      "The Men Wrestling emoji is a ZWJ sequence combining 🤼 People Wrestling, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025894-916",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤼 People Wrestling",
    "activity-href": "https://emojipedia.org/people-wrestling/",
    emoji: "🤼",
    emojiName: "🤼 People Wrestling",
    description: "Two people in the sport of wrestling.",
  },
  {
    "web-scraper-order": "1666025898-917",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤸‍♀️ Woman Cartwheeling",
    "activity-href": "https://emojipedia.org/woman-cartwheeling/",
    emoji: "🤸‍♀️",
    emojiName: "🤸‍♀️ Woman Cartwheeling",
    description:
      "The Woman Cartwheeling emoji is a ZWJ sequence combining 🤸 Person Cartwheeling, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025902-919",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤸‍♂️ Man Cartwheeling",
    "activity-href": "https://emojipedia.org/man-cartwheeling/",
    emoji: "🤸‍♂️",
    emojiName: "🤸‍♂️ Man Cartwheeling",
    description:
      "The Man Cartwheeling emoji is a ZWJ sequence combining 🤸 Person Cartwheeling, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025906-921",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤸 Person Cartwheeling",
    "activity-href": "https://emojipedia.org/person-cartwheeling/",
    emoji: "🤸",
    emojiName: "🤸 Person Cartwheeling",
    description:
      "A person doing a cartwheel, representing the sport of gymnastics.",
  },
  {
    "web-scraper-order": "1666025912-923",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚵‍♀️ Woman Mountain Biking",
    "activity-href": "https://emojipedia.org/woman-mountain-biking/",
    emoji: "🚵‍♀️",
    emojiName: "🚵‍♀️ Woman Mountain Biking",
    description: "The female version of the 🚵 Mountain Bicyclist emoji.",
  },
  {
    "web-scraper-order": "1666025918-926",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚵‍♂️ Man Mountain Biking",
    "activity-href": "https://emojipedia.org/man-mountain-biking/",
    emoji: "🚵‍♂️",
    emojiName: "🚵‍♂️ Man Mountain Biking",
    description:
      "The male version of the 🚵 Mountain Bicyclist emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025923-928",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚵 Person Mountain Biking",
    "activity-href": "https://emojipedia.org/person-mountain-biking/",
    emoji: "🚵",
    emojiName: "🚵 Person Mountain Biking",
    description:
      "A person (cyclist) who rides a mountain bike: a type of off-road bicycle. Intended to be gender-neutral.",
  },
  {
    "web-scraper-order": "1666025928-930",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚴‍♀️ Woman Biking",
    "activity-href": "https://emojipedia.org/woman-biking/",
    emoji: "🚴‍♀️",
    emojiName: "🚴‍♀️ Woman Biking",
    description: "The female version of the 🚴 Bicyclist emoji.",
  },
  {
    "web-scraper-order": "1666025933-932",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚴‍♂️ Man Biking",
    "activity-href": "https://emojipedia.org/man-biking/",
    emoji: "🚴‍♂️",
    emojiName: "🚴‍♂️ Man Biking",
    description:
      "The male version of the 🚴 Bicyclist emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025937-934",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚴 Person Biking",
    "activity-href": "https://emojipedia.org/person-biking/",
    emoji: "🚴",
    emojiName: "🚴 Person Biking",
    description:
      "A person riding a bicycle for leisure, sport or transport. Intended to be gender-neutral.",
  },
  {
    "web-scraper-order": "1666025943-937",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏋️‍♀️ Woman Lifting Weights",
    "activity-href": "https://emojipedia.org/woman-lifting-weights/",
    emoji: "🏋️‍♀️",
    emojiName: "🏋️‍♀️ Woman Lifting Weights",
    description: "The female version of the 🏋 Weight Lifter emoji.",
  },
  {
    "web-scraper-order": "1666025946-940",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏋️‍♂️ Man Lifting Weights",
    "activity-href": "https://emojipedia.org/man-lifting-weights/",
    emoji: "🏋️‍♂️",
    emojiName: "🏋️‍♂️ Man Lifting Weights",
    description:
      "The male version of the 🏋 Weight Lifter emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025950-944",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏋️ Person Lifting Weights",
    "activity-href": "https://emojipedia.org/person-lifting-weights/",
    emoji: "🏋️",
    emojiName: "🏋️ Person Lifting Weights",
    description:
      "A person lifting a barbell loaded with weights above their head.",
  },
  {
    "web-scraper-order": "1666025959-947",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛹️‍♀️ Woman Bouncing Ball",
    "activity-href": "https://emojipedia.org/woman-bouncing-ball/",
    emoji: "⛹️‍♀️",
    emojiName: "⛹️‍♀️ Woman Bouncing Ball",
    description: "The female version of the ⛹ Person With Ball emoji.",
  },
  {
    "web-scraper-order": "1666025963-952",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛹️‍♂️ Man Bouncing Ball",
    "activity-href": "https://emojipedia.org/man-bouncing-ball/",
    emoji: "⛹️‍♂️",
    emojiName: "⛹️‍♂️ Man Bouncing Ball",
    description:
      "The male version of the ⛹ Person With Ball emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025967-956",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛹️ Person Bouncing Ball",
    "activity-href": "https://emojipedia.org/person-bouncing-ball/",
    emoji: "⛹️",
    emojiName: "⛹️ Person Bouncing Ball",
    description:
      "A person with a ball, which is generally displayed as a basketballer running and dribbling (bouncing) the basketball.",
  },
  {
    "web-scraper-order": "1666025970-960",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏊‍♀️ Woman Swimming",
    "activity-href": "https://emojipedia.org/woman-swimming/",
    emoji: "🏊‍♀️",
    emojiName: "🏊‍♀️ Woman Swimming",
    description: "The female version of the 🏊 Swimmer emoji.",
  },
  {
    "web-scraper-order": "1666025974-965",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏊‍♂️ Man Swimming",
    "activity-href": "https://emojipedia.org/man-swimming/",
    emoji: "🏊‍♂️",
    emojiName: "🏊‍♂️ Man Swimming",
    description:
      "The male version of the 🏊 Swimmer emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025978-967",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏊 Person Swimming",
    "activity-href": "https://emojipedia.org/person-swimming/",
    emoji: "🏊",
    emojiName: "🏊 Person Swimming",
    description:
      "A person swimming in a pool, the ocean, or another body of water. Lacked goggles on prior versions of iOS.",
  },
  {
    "web-scraper-order": "1666025981-971",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚣‍♀️ Woman Rowing Boat",
    "activity-href": "https://emojipedia.org/woman-rowing-boat/",
    emoji: "🚣‍♀️",
    emojiName: "🚣‍♀️ Woman Rowing Boat",
    description: "The female version of the 🚣 Rowboat emoji.",
  },
  {
    "web-scraper-order": "1666025984-974",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚣‍♂️ Man Rowing Boat",
    "activity-href": "https://emojipedia.org/man-rowing-boat/",
    emoji: "🚣‍♂️",
    emojiName: "🚣‍♂️ Man Rowing Boat",
    description:
      "The male version of the 🚣 Rowboat emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025986-977",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚣 Person Rowing Boat",
    "activity-href": "https://emojipedia.org/person-rowing-boat/",
    emoji: "🚣",
    emojiName: "🚣 Person Rowing Boat",
    description:
      "A small rowboat suitable for a small number of people. Couples or families sometimes hire these as an activity on calm waters.",
  },
  {
    "web-scraper-order": "1666025991-982",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏄‍♀️ Woman Surfing",
    "activity-href": "https://emojipedia.org/woman-surfing/",
    emoji: "🏄‍♀️",
    emojiName: "🏄‍♀️ Woman Surfing",
    description: "The female version of the 🏄 Surfer emoji.",
  },
  {
    "web-scraper-order": "1666025995-985",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏄‍♂️ Man Surfing",
    "activity-href": "https://emojipedia.org/man-surfing/",
    emoji: "🏄‍♂️",
    emojiName: "🏄‍♂️ Man Surfing",
    description:
      "The male version of the 🏄 Surfer emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025998-988",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏄 Person Surfing",
    "activity-href": "https://emojipedia.org/person-surfing/",
    emoji: "🏄",
    emojiName: "🏄 Person Surfing",
    description:
      "A person on a surfboard, riding on a wave in the ocean. Wears a wetsuit or board shorts in most versions.",
  },
  {
    "web-scraper-order": "1666026002-992",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏌️‍♀️ Woman Golfing",
    "activity-href": "https://emojipedia.org/woman-golfing/",
    emoji: "🏌️‍♀️",
    emojiName: "🏌️‍♀️ Woman Golfing",
    description: "The female version of the 🏌 Golfer emoji.",
  },
  {
    "web-scraper-order": "1666026006-995",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏌️‍♂️ Man Golfing",
    "activity-href": "https://emojipedia.org/man-golfing/",
    emoji: "🏌️‍♂️",
    emojiName: "🏌️‍♂️ Man Golfing",
    description:
      "The male version of the 🏌 Golfer emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666026010-1000",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏌️ Person Golfing",
    "activity-href": "https://emojipedia.org/person-golfing/",
    emoji: "🏌️",
    emojiName: "🏌️ Person Golfing",
    description:
      "A person swinging a golf club, attempting to hit a golf ball toward the flag on the green.",
  },
  {
    "web-scraper-order": "1666026014-1004",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏂 Snowboarder",
    "activity-href": "https://emojipedia.org/snowboarder/",
    emoji: "🏂",
    emojiName: "🏂 Snowboarder",
    description:
      "A person snowboarding downhill at a ski resort. Wearing clothing designed for cold climates.",
  },
  {
    "web-scraper-order": "1666026017-1007",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛷️ Skier",
    "activity-href": "https://emojipedia.org/skier/",
    emoji: "⛷️",
    emojiName: "⛷️ Skier",
    description:
      "A person downhill-skiiing. Displayed with poles and skis, generally wearing a mask.",
  },
  {
    "web-scraper-order": "1666026021-1011",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏇 Horse Racing",
    "activity-href": "https://emojipedia.org/horse-racing/",
    emoji: "🏇",
    emojiName: "🏇 Horse Racing",
    description:
      "A jockey riding a horse in a horse race. Shown riding to the left of screen on all major platforms. Emoji modifiers change the skin tone of the jockey on some platforms, which can be difficult to discern at small sizes.",
  },
  {
    "web-scraper-order": "1666026025-1014",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤺 Person Fencing",
    "activity-href": "https://emojipedia.org/person-fencing/",
    emoji: "🤺",
    emojiName: "🤺 Person Fencing",
    description:
      "A person shown in the sport of fencing, with a Rapier-style sword, mask, and protective clothing.",
  },
  {
    "web-scraper-order": "1666026030-1018",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧗‍♀️ Woman Climbing",
    "activity-href": "https://emojipedia.org/woman-climbing/",
    emoji: "🧗‍♀️",
    emojiName: "🧗‍♀️ Woman Climbing",
    description:
      "A female rock climber, shown climbing up a rock formation. Some platforms show the climber with a helmet, and/or rope.",
  },
  {
    "web-scraper-order": "1666026034-1023",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧗‍♂️ Man Climbing",
    "activity-href": "https://emojipedia.org/man-climbing/",
    emoji: "🧗‍♂️",
    emojiName: "🧗‍♂️ Man Climbing",
    description:
      "A male rock climber, shown climbing up a rock formation. Some platforms show the climber with a helmet, and/or rope.",
  },
  {
    "web-scraper-order": "1666026038-1027",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧗 Person Climbing",
    "activity-href": "https://emojipedia.org/person-climbing/",
    emoji: "🧗",
    emojiName: "🧗 Person Climbing",
    description:
      "A rock climber, shown climbing up a rock formation. Some platforms show the climber with a helmet and/or rope. The Emojipedia Sample image was created with assistance from World Champion Rock Climber Sasha DiGiulian.",
  },
  {
    "web-scraper-order": "1666026040-1030",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🕴️ Person in Suit Levitating",
    "activity-href": "https://emojipedia.org/person-in-suit-levitating/",
    emoji: "🕴️",
    emojiName: "🕴️ Person in Suit Levitating",
    description:
      "A person wearing a suit, hovering above the ground with a shadow displayed beneath them. Generally shown wearing a fedora or similar style of hat.",
  },
];
export default activity;
